export class RecaptchaSafety {

    // devSefaz - Desenvolvimento
    public static  AmbienteUsoObrigatorioRecaptcha = 'prod';
}


// WEBPACK FOOTER //
// ./src/app/shared/security/RecaptchaSafety.ts